import { Pipe, PipeTransform } from '@angular/core';
import { isNullOrUndefined } from 'util';

@Pipe({
  name: 'ifNull'
})
export class IfNullPipe implements PipeTransform {
  transform(value: any, defaultValue: any): any {
    return (isNullOrUndefined(value)) ? defaultValue : value;
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/shared/pipes/if-null.pipe.ts